import { createContext, useContext } from 'react';

export type DemoScaledPortalContextValue = {
  scale: number;
};

export const DemoScaledPortalContext = createContext<DemoScaledPortalContextValue | null>(
  null,
);

export const useDemoScaledPortal = () => useContext(DemoScaledPortalContext);
